"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function default_1({ useOnce } = {}) {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const onVisibilityChange = () => {
        if (document.visibilityState === 'hidden')
            setVisible(false);
        else if (document.visibilityState === 'visible') {
            setVisible(true);
            if (useOnce)
                removeVisibilityChangeEvent();
        }
    };
    const removeVisibilityChangeEvent = () => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        hasVisibilityChangeEvent.current = false;
    };
    const hasVisibilityChangeEvent = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (document.visibilityState === 'visible') {
            setVisible(true);
            if (useOnce) {
                hasVisibilityChangeEvent.current = true;
            }
        }
        if (!hasVisibilityChangeEvent.current) {
            document.addEventListener('visibilitychange', onVisibilityChange);
            hasVisibilityChangeEvent.current = true;
        }
        return () => {
            removeVisibilityChangeEvent();
        };
    }, []);
    return visible;
}
exports.default = default_1;
